const API_BASE = ((import.meta as any).env?.VITE_API_URL as string | undefined)?.replace(/\/$/, "") || "";

export function merchantApiPath(path: string): string {
  return API_BASE ? `${API_BASE}${path}` : path;
}

export function merchantFetch(path: string, init: RequestInit = {}) {
  return fetch(merchantApiPath(path), {
    ...init,
    credentials: "include",
  });
}
